export const editFormData = {
    id: 'defaultInspectionEditForm',
    name: 'Inspection Data Edit Form',
    version: 1,
    sections: [
        {
            name: 'Inspection',
            entries: [
                {
                    typeId: 'shortText',
                    field: 'type',
                    instructions: '',
                    label: 'Inspection',
                    additionalInfo: '',
                    rules: [],
                    visibilityConditions: null,
                    mask: null,
                    fieldMapping: {
                        targetPath: '$.inspection.type.name',
                    },
                },
                {
                    typeId: 'shortText',
                    field: 'inspector',
                    width: 12,
                    instructions: '',
                    label: 'Inspector',
                    additionalInfo: '',
                    rules: [],
                    visibilityConditions: null,
                    fieldMapping: {
                        targetPath: '$.inspection.inspector.name',
                    },
                    mask: null,
                },
                {
                    typeId: 'spacer',
                    field: 'addressSpacer',
                },
                {
                    typeId: 'shortText',
                    field: 'inspectionDate',
                    width: 12,
                    instructions: '',
                    label: 'Inspection Date',
                    additionalInfo: '',
                    rules: [],
                    visibilityConditions: null,
                    fieldMapping: {
                        targetPath: '$.inspection.inspectionDate',
                    },
                    mask: null,
                },
                {
                    typeId: 'shortText',
                    field: 'status',
                    width: 12,
                    instructions: '',
                    label: 'Status',
                    additionalInfo: '',
                    rules: [],
                    visibilityConditions: null,
                    fieldMapping: {
                        targetPath: '$.inspection.status',
                    },
                    mask: null,
                },
                {
                    typeId: 'shortText',
                    field: 'comment',
                    width: 12,
                    instructions: '',
                    label: 'Comment',
                    additionalInfo: '',
                    rules: [],
                    visibilityConditions: null,
                    fieldMapping: {
                        targetPath: '$.inspection.comment',
                    },
                    mask: null,
                },
            ],
        },
        {
            name: 'Specialties',
            entries: [
                {
                    typeId: 'multiple',
                    field: 'specialties',
                    width: 12,
                    instructions: '',
                    label: 'Specialties',
                    additionalInfo: '',
                    rules: [],
                    visibilityConditions: null,
                    fieldMapping: {
                        targetPath: '$.specialties',
                    },
                    fields: [
                        {
                            typeId: 'choices',
                            field: 'specialty',
                            width: 12,
                            instructions: '',
                            label: 'Specialty',
                            additionalInfo: '',
                            rules: [],
                            visibilityConditions: null,
                            fieldMapping: {
                                targetPath: '$.name',
                            },
                            choices: [
                                {
                                    label: 'New Choice',
                                    value: 'New Choice',
                                },
                                {
                                    label: 'New Choice',
                                    value: 'New Choice',
                                },
                                {
                                    label: 'New Choice',
                                    value: 'New Choice',
                                },
                            ],
                        },
                    ],
                    displayExpression: '',
                    secondaryDisplayExpression: '',
                },
            ],
        },
    ],
};
